module.exports = "/_next/static/images/rawat-inap-ccSVG-a9a4fcc4790ed8df7222fb418e579866.svg";